// src/utils/statusUtils.js
export const getStatusColor = (status, type = 'call') => {
    const baseColors = {
      'call': {
        'initiated': 'bg-blue-100 text-blue-800',
        'success': 'bg-green-100 text-green-800',
        'failure': 'bg-red-100 text-red-800',
        'rescheduled': 'bg-yellow-100 text-yellow-800',
      },
      'patient': {
        'Active': 'bg-green-100 text-green-800',
        'Inactive': 'bg-red-100 text-red-800',
      },
      'enrollment': {
        'active': 'bg-green-100 text-green-800',
        'inactive': 'bg-red-100 text-red-800',
        'completed': 'bg-red-100 text-red-800',
      },
      'user': {
        'active': 'bg-green-100 text-green-800',
        'inactive': 'bg-gray-100 text-gray-800',
      },
    };
  
    return baseColors[type]?.[status] || 'bg-gray-100 text-gray-800';
  };